import { render, staticRenderFns } from "./orderHandlingTvat.vue?vue&type=template&id=740e4a58&"
import script from "./orderHandlingTvat.vue?vue&type=script&lang=js&"
export * from "./orderHandlingTvat.vue?vue&type=script&lang=js&"
import style0 from "./orderHandlingTvat.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderHandlingTvat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports